import {
    ChangeDetectorRef,
    Component,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import moment from 'moment';
import { Observable, ReplaySubject } from 'rxjs';
import { filter, takeWhile, tap } from 'rxjs/operators';
import { CompanySetting } from '../../company-setting';
import { AccrualPeriodModel } from '../../data-services/accrual-period/accrual-period.model';
import { columnResize } from '../../shared/columnResize';
import { SelectItem, Table } from '../../shared/efaact-primeng.module';
import { DisplayErrors } from '../../shared/errors-sidenav';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { IUser, IUserInfo } from '../../user-info';
import * as fromUser from '../../user-info/store/user.reducer';
import { ICurrentLeaveSummary } from '../ICurrentLeaveSummary';
import { LeaveAdjustment } from '../ILeaveAdjustment';

@Component({
    selector: 'ef-leave-adjustment-presenter',
    templateUrl: './leave-adjustment-presenter.component.html',
    styleUrls: ['./leave-adjustment-presenter.component.scss'],
    standalone: false
})
export class LeaveAdjustmentPresenterComponent
    extends DisplayErrors<LeaveAdjustment>
    implements OnInit, OnDestroy
{
    currentLeaveSummaryElements: HTMLCollection;
    leaveHistoryElements: HTMLCollection;
    dateRangeFormGroup: UntypedFormGroup;
    selectedEmployeeListID: any;
    filteredAdjustments: LeaveAdjustment[];
    oldValue: any;
    usingIntuitPayroll: boolean;
    accrualPeriodsSelectItems: SelectItem[];
    leaveInfo: string | undefined;
    private AdjustmentsSubject = new ReplaySubject<Array<LeaveAdjustment>>(1);
    private _adjustments: Array<LeaveAdjustment>;
    lagDaysErrorMessage: string | null;
    showAreYouSure = false;
    dataForAreYouSure: ICurrentLeaveSummary;
    commitAccrualHistoryAdjustmentsStatusMsg: string;
    showCommitErrorStatusMsg = false;
    showCommitWarningStatusMsg = false;
    showCommitSuccessStatusMsg = false;
    commitMsg: any[] = [];
    indexForAreYouSure: number;
    working = false;
    historyNameFilterSelectItem: SelectItem[];
    historyVacPeriodFilterSelectItem: SelectItem[];
    historySickPeriodFilterSelectItem: SelectItem[];
    historyPPSFilterSelectItem: SelectItem[];
    historyPPEFilterSelectItem: SelectItem[];
    historyUsersSelectItem: SelectItem[];
    filteredHistory: LeaveAdjustment[] = [];
    selectedUsers: any;
    defaultAdj: LeaveAdjustment[];

    IsColumnFrozen = false;

    @Input() set adjustments(value: Array<LeaveAdjustment>) {
        if (value && value.length > 0) {
            this.defaultAdj = value;
            if (this.hideZeroCbxValue == true) {
                const filtered = [] as LeaveAdjustment[]; //value.filter(x => x.Vac_HoursEarned != 0 || x.Sick_HoursEarned != 0);
                //filtered = filtered.filter(x => x.Vac_HoursEarnedAdjust != null || x.Sick_HoursEarnedAdjust != null);

                value.forEach(x => {
                    if (
                        x.Vac_HoursEarned == 0 &&
                        x.Vac_HoursEarnedAdjust == null
                    ) {
                        //do not display
                    } else if (
                        x.Vac_HoursEarned == 0 &&
                        x.Vac_HoursEarnedAdjust != null
                    ) {
                        filtered.push(x);
                    } else {
                        filtered.push(x);
                    }
                });
                this._adjustments = filtered;
                this.AdjustmentsSubject.next(filtered);
            } else {
                this._adjustments = value;
                this.AdjustmentsSubject.next(this._adjustments);
            }

            if (value[0].Status.Message != null) {
                this.commitMsg = [];
                // this.commitAccrualHistoryAdjustmentsStatusMsg = value[0].Status.Message;
                if (value[0].Status.Message.includes('Error')) {
                    this.commitMsg.push({
                        severity: 'error',
                        detail: value[0].Status.Message
                    });
                    this.showCommitErrorStatusMsg = true;
                    this.working = false;
                } else {
                    this.showCommitErrorStatusMsg = false;
                }
                if (value[0].Status.Message.includes('Warning')) {
                    this.commitMsg.push({
                        severity: 'warn',
                        detail: value[0].Status.Message
                    });
                    this.showCommitWarningStatusMsg = true;
                    this.working = false;
                } else {
                    this.showCommitWarningStatusMsg = false;
                }
                if (value[0].Status.Message.includes('Success')) {
                    this.commitMsg.push({
                        severity: 'success',
                        detail: value[0].Status.Message
                    });
                    this.showCommitSuccessStatusMsg = true;
                    this.working = false;
                } else {
                    this.showCommitSuccessStatusMsg = false;
                }
            }
            this.historyNameFilterSelectItem = value.map(x => ({
                value: x.EmployeeName,
                label: x.EmployeeName
            }));
            this.historyNameFilterSelectItem =
                this.historyNameFilterSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.label === v.label) === i
                );
            this.historyVacPeriodFilterSelectItem = value.map(x => ({
                value: x.VacAccrualPeriod,
                label: x.VacAccrualPeriod
            }));
            this.historyVacPeriodFilterSelectItem =
                this.historyVacPeriodFilterSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.label === v.label) === i
                );
            this.historySickPeriodFilterSelectItem = value.map(x => ({
                value: x.SickAccrualPeriod,
                label: x.SickAccrualPeriod
            }));
            this.historySickPeriodFilterSelectItem =
                this.historySickPeriodFilterSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.label === v.label) === i
                );
            this.historyPPSFilterSelectItem = value.map(x => ({
                value: x.PPS,
                label: moment(x.PPS).format('MM/DD/YYYY')
            }));
            this.historyPPSFilterSelectItem =
                this.historyPPSFilterSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.label === v.label) === i
                );
            this.historyPPEFilterSelectItem = value.map(x => ({
                value: x.PPE,
                label: moment(x.PPE).format('MM/DD/YYYY')
            }));
            this.historyPPEFilterSelectItem =
                this.historyPPEFilterSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.label === v.label) === i
                );
            this.historyUsersSelectItem = value.map(x => ({
                value: x.EmployeeListID,
                label: x.EmployeeName
            }));
            this.historyUsersSelectItem = this.historyUsersSelectItem.filter(
                (v, i, a) => a.findIndex(t => t.label === v.label) === i
            );
            if (this.IsLoading == true) {
                this.displayRecalcText = true;
                this.IsLoading = false;
            }

            if (this.filteredHistory && this.filteredHistory.length > 0) {
                this.LATable.clear();
                this.filteredHistory = this._adjustments.filter(x =>
                    this.selectedUsers.includes(x.EmployeeListID)
                );
                this.LATable.value = this.filteredHistory;
            }
        }
    }
    get adjustments(): Array<LeaveAdjustment> {
        return this._adjustments;
    }

    summaryNameFilterSelectItem: SelectItem[];
    summarySickPeriodFilterSelectItem: SelectItem[];
    summaryVacPeriodFilterSelectItem: SelectItem[];
    private SummarySubject = new ReplaySubject<Array<ICurrentLeaveSummary>>(1);
    private _summary: Array<ICurrentLeaveSummary>;
    @Input() set summary(value: Array<ICurrentLeaveSummary>) {
        if (value) {
            this._summary = value;
            // this._summary.map(x => x.id == x.EmployeeListID);
            this._summary.forEach(s => {
                if (s.Sick_Accrualperiod && s.Vac_Accrualperiod) {
                    s.Sick_Accrualperiod = s.Sick_Accrualperiod.toLowerCase();
                    s.Vac_Accrualperiod = s.Vac_Accrualperiod.toLowerCase();
                }
            });
            this.SummarySubject.next(this._summary);

            this.summaryNameFilterSelectItem = value.map(x => ({
                value: x.EmployeeName,
                label: x.EmployeeName
            }));
            this.summaryNameFilterSelectItem =
                this.summaryNameFilterSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.label === v.label) === i
                );
            this.summarySickPeriodFilterSelectItem = value.map(x => ({
                value: x.Sick_Accrualperiod,
                label: x.Sick_Accrualperiod
            }));
            this.summarySickPeriodFilterSelectItem =
                this.summarySickPeriodFilterSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.label === v.label) === i
                );
            this.summaryVacPeriodFilterSelectItem = value.map(x => ({
                value: x.Vac_Accrualperiod,
                label: x.Vac_Accrualperiod
            }));
            this.summaryVacPeriodFilterSelectItem =
                this.summaryVacPeriodFilterSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.label === v.label) === i
                );
        }
    }
    get summary(): Array<ICurrentLeaveSummary> {
        return this._summary;
    }

    LagDaysSubject = new ReplaySubject<CompanySetting>(1);
    private _lagdays: CompanySetting;
    @Input() set lagDays(value: CompanySetting) {
        if (value) {
            this._lagdays = value;
            // this._lagdays.filter(x => x.SettingType == "PayPeriodLagInDays" && x.CatID == 4);
            this.lagDaysValue = this._lagdays.SettingValue;
            this.lagDaysLabel = this._lagdays.SettingTypeLabel;
            this.LagDaysSubject.next(this._lagdays);
            if (this._lagdays.Status.StatusCode == 3) {
                this.lagDaysErrorMessage = this._lagdays.Status.Message;
            } else {
                this.lagDaysErrorMessage = null;
            }
        }
    }
    get lagDays(): CompanySetting {
        return this._lagdays;
    }

    AccrualPeriodsSubject = new ReplaySubject<Array<AccrualPeriodModel>>(1);
    private _accrualperiods: Array<AccrualPeriodModel>;
    @Input() set accrualPeriods(value: Array<AccrualPeriodModel>) {
        if (value && value.length > 0) {
            this._accrualperiods = value;

            this.accrualPeriodsSelectItems = this._accrualperiods.map(x => ({
                label: x.AccrueLeavePeriod,
                value: x.AccrueLeavePeriod
            }));

            this.AccrualPeriodsSubject.next(this._accrualperiods);
        }
    }
    get accrualPeriods(): Array<AccrualPeriodModel> {
        return this._accrualperiods;
    }

    public userInfoSubject = new ReplaySubject<IUserInfo>(1);
    public userSub$: Observable<IUser>;
    @Output() SaveAccrualPeriod = new ReplaySubject<AccrualPeriodModel>(1);
    @Output() SaveLagDays = new ReplaySubject<CompanySetting>(1);
    @Output() SaveSummary = new ReplaySubject<ICurrentLeaveSummary>(1);
    @Output() SaveAdjustment = new ReplaySubject<LeaveAdjustment>(1);
    @Output() RecalcAdjustment = new ReplaySubject<LeaveAdjustment>(1);
    @Output() LoadAdjustments = new ReplaySubject<Array<any>>(1);
    public editing_LA?: LeaveAdjustment = {} as LeaveAdjustment;
    public editing_Summary?: ICurrentLeaveSummary = {} as ICurrentLeaveSummary;
    clonedAdjustments: { [i: string]: LeaveAdjustment } = {};
    clonedSummary: { [i: string]: ICurrentLeaveSummary } = {};
    active = true;
    moment: any;
    tableScrollHeight = '50em';
    prevPayPeriodStart: Date;
    prevPayPeriodEnd: Date;
    lagDaysValue: string;
    lagDaysLabel: string;
    PPE: Date;
    PPS: Date;
    displayRecalcText = false;
    recalcText: string;
    IsLoading: boolean;
    displayAreYouSure = false;
    cbxValue = false;
    hideZeroCbxValue = true;

    ppsFormGroup: UntypedFormGroup;
    ppeFormGroup: UntypedFormGroup;
    empFormGroup: UntypedFormGroup;
    apFormGroup: UntypedFormGroup;

    cols = [
        { field: 'PPS', header: 'Pay Period Start' },
        { field: 'PPE', header: 'Pay Period End' },
        { field: 'EmployeeName', header: 'Name' },
        { field: 'VacAccrualPeriod', header: 'Vac Accrual Period' },
        { field: 'Vac_HoursSetting', header: 'Vac Hours Setting' },
        { field: 'Vac_EarnedRate', header: 'Vac Earned Rate' },
        { field: 'Vac_HoursEarned', header: 'Vac Hours Earned' },
        { field: 'Vac_HoursEarnedAdjust', header: 'Vac Hours Earned Override' },
        { field: 'Vac_EarnedCost', header: 'Vac Earned Cost' },
        { field: 'Vac_EarnedCostAdjust', header: 'Vac Earned Cost Override' },
        { field: 'Vac_HoursTaken', header: 'Vac Taken' },
        { field: 'SickAccrualPeriod', header: 'Sick Accrual Period' },
        { field: 'Sick_HoursSetting', header: 'Sick Hours Setting' },
        { field: 'Sick_EarnedRate', header: 'Sick Earned Rate' },
        { field: 'Sick_HoursEarned', header: 'Sick Hours Earned' },
        {
            field: 'Sick_HoursEarnedAdjust',
            header: 'Sick Hours Earned Override'
        },
        { field: 'Sick_EarnedCost', header: 'Sick Earned Cost' },
        { field: 'Sick_EarnedCostAdjust', header: 'Sick Earned Cost Override' },
        { field: 'Sick_HoursTaken', header: 'Sick Taken' }
    ];

    @ViewChild('LATable', { static: true }) LATable: Table;
    @ViewChild('SummaryTable', { static: true }) SummaryTable: Table;

    activeState = [true, true];
    hTabHeight: any;
    sTabHeight: any;
    tabHeight: any;

    public currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });

    public summaryPanelOpen = true;
    public historyPanelOpen = false;
    public activeAccordionIndexes: number[] = [0];

    constructor(
        @Inject(LoggingService) private log: LoggingService,
        private userStore: Store<fromUser.State>,
        protected cdRef: ChangeDetectorRef
    ) {
        super();
        this.moment = moment;
        this.dateRangeFormGroup = new UntypedFormGroup({
            dateRange: new UntypedFormControl(null)
        });
        this.ppsFormGroup = new UntypedFormGroup({
            PPS: new UntypedFormControl(null)
        });
        this.ppeFormGroup = new UntypedFormGroup({
            PPE: new UntypedFormControl(null)
        });
        this.empFormGroup = new UntypedFormGroup({
            Employee: new UntypedFormControl(null)
        });
        this.apFormGroup = new UntypedFormGroup({
            AccrualPeriod: new UntypedFormControl(null)
        });
    }

    ngOnInit() {
        this.setupObservables();
        this.setupSubscriptions();
        this.syncAccordionState();
        this.currentLeaveSummaryElements =
            document.getElementsByClassName('p-header-cell');
        this.leaveHistoryElements =
            document.getElementsByClassName('p-header-cell');
    }

    ngAfterViewInit() {
        this.IsColumnFrozen = true;
    }

    ngOnDestroy() {
        this.active = false;
    }

    onColumnResize_hist($event) {
        const table = document.querySelectorAll('table')[1];
        columnResize($event, 5, table);
    }
    onColumnResize_summary($event) {
        const table = document.querySelectorAll('table')[0];
        columnResize($event, 6, table);
    }
    setupObservables() {
        this.log.verbose({
            type: 'LeaveAdjustmentPresenterComponent:setupObservables'
        });
        this.userSub$ = this.userStore.pipe(
            takeWhile(_ => this.active),
            select(fromUser.getUser)
        );
    }

    setupSubscriptions() {
        this.userSub$
            .pipe(
                takeWhile(() => this.active),
                tap(x =>
                    this.log.verbose({
                        type: 'LeaveAdjustmentPresenterComponent:userSub$',
                        x
                    })
                ),
                filter(x => !!x)
            )
            .subscribe(user => {
                this.userInfoSubject.next(user.userInfo);
                this.usingIntuitPayroll =
                    user.userInfo.UsingIntuitPayroll ?? false;
                this.prevPayPeriodStart = user.userInfo.PrevPayPeriodStart;
                this.prevPayPeriodEnd = user.userInfo.PrevPayPeriodEnd;
                this.dateRangeFormGroup.controls['dateRange'].patchValue([
                    new Date(this.prevPayPeriodStart),
                    new Date(this.prevPayPeriodEnd)
                ]);
                this.PPS = this.prevPayPeriodStart;
                this.PPE = this.prevPayPeriodEnd;
                this.leaveInfo = user.userInfo.LeaveAccrualInfo;
            });
        // this.AdjustmentsSubject.pipe(
        //   takeWhile(() => this.active)
        // ).subscribe(adjustments => { });
        this.dateRangeFormGroup.controls['dateRange'].valueChanges
            .pipe(
                tap(value =>
                    this.log.verbose({
                        type: 'dateRangeFormGroup:valueChanges',
                        value
                    })
                ),
                takeWhile(_ => this.active)
            )
            .subscribe(value => {
                this.LoadAdjustments.next(value);
                if (moment(value[0]).isValid() && moment(value[1]).isValid()) {
                    this.PPS = value[0];
                    this.PPE = value[1];
                    this.displayRecalcText = false;
                    this.recalcText = '';
                }
            });
    }

    // vacAccrualPeriodValueChanged(value) {
    //     this.SaveAccrualPeriod.next(value);
    // }

    // sickAccrualPeriodValueChanged(value) {
    //     this.SaveAccrualPeriod.next(value);
    // }

    // findAccrualPeriod(rowData: ICurrentLeaveSummary): string {
    //     if (rowData.Accr != null) {
    //         if (rowData.CostCenterID === 0) {
    //             return "";
    //         } else {
    //             const cc = this.userGroups.find(
    //                 x => x.GroupID === rowData.CostCenterID
    //             );
    //             return cc.GroupName;
    //         }
    //     } else {
    //         return '';
    //     }
    // }

    onUpdateLagDaysClicked() {
        this.lagDays.SettingValue = this.lagDaysValue;
        const data: CompanySetting = {
            CatID: this.lagDays.CatID,
            CatDescription: this.lagDays.CatDescription,
            SettingType: this.lagDays.SettingType,
            SettingTypeLabel: this.lagDays.SettingTypeLabel,
            SettingValue: this.lagDaysValue,
            CtrlType: this.lagDays.CtrlType,
            Validation: this.lagDays.Validation,
            Isconfirmrequired: this.lagDays.Isconfirmrequired,
            Isreadonly: this.lagDays.Isreadonly,
            Status: this.lagDays.Status,
            Row_Version: this.lagDays.Row_Version
        };
        this.SaveLagDays.next(data);
    }

    // ----------------------Current Leave Summary Table-------------------------------
    onEmployeeSelected(value) {
        this.selectedEmployeeListID = value.data.EmployeeListID;

        if (this.oldValue) {
            const s1_oldRow = document.getElementById(
                `row-1-${this.oldValue.data.EmployeeListID.toString()}`
            );
            if (s1_oldRow) {
                s1_oldRow.classList.remove('highlight');
            }
            const s_oldRow = document.getElementById(
                `row-${this.oldValue.data.EmployeeListID.toString()}`
            );
            if (s_oldRow) {
                s_oldRow.classList.remove('highlight');
            }
        }

        const s1_row = document.getElementById(
            `row-1-${value.data.EmployeeListID.toString()}`
        );
        if (!s1_row) {
            return;
        }
        s1_row.classList.add('highlight');

        const s_row = document.getElementById(
            `row-${value.data.EmployeeListID.toString()}`
        );
        if (!s_row) {
            return;
        }
        s_row.classList.add('highlight');
        this.oldValue = value;
        if (this.filteredAdjustments) {
            if (this.filteredAdjustments.length > 0) {
                const oldRow = document.getElementById(
                    `row-${this.filteredAdjustments[0].Uniqueid.toString()}`
                );
                if (oldRow) {
                    oldRow.classList.remove('highlight');
                }
                const oldRow1 = document.getElementById(
                    `row-1-${this.filteredAdjustments[0].Uniqueid.toString()}`
                );
                if (oldRow1) {
                    oldRow1.classList.remove('highlight');
                }

                this.filteredAdjustments = this.adjustments.filter(
                    x => x.EmployeeListID == this.selectedEmployeeListID
                );
                if (this.filteredAdjustments.length > 0) {
                    const f_row = document.getElementById(
                        `row-1-${this.filteredAdjustments[0].Uniqueid.toString()}`
                    );
                    if (!f_row) {
                        return;
                    }
                    f_row.classList.add('highlight');
                    const row = document.getElementById(
                        `row-${this.filteredAdjustments[0].Uniqueid.toString()}`
                    );
                    if (!row) {
                        return;
                    }
                    row.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'nearest'
                    });
                    row.classList.add('highlight');
                    this.log.verbose(row);
                }
            }
        }

        this.filteredAdjustments = this.adjustments.filter(
            x => x.EmployeeListID == this.selectedEmployeeListID
        );
        if (this.filteredAdjustments.length > 0) {
            const f_row = document.getElementById(
                `row-1-${this.filteredAdjustments[0].Uniqueid.toString()}`
            );
            if (!f_row) {
                return;
            }
            f_row.classList.add('highlight');
            const row = document.getElementById(
                `row-${this.filteredAdjustments[0].Uniqueid.toString()}`
            );
            if (!row) {
                return;
            }
            row.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });
            row.classList.add('highlight');
            this.log.verbose(row);
        }
    }

    confirmSave() {
        this.SaveSummary.next(this.dataForAreYouSure);
        delete this.clonedSummary[this.dataForAreYouSure.EmployeeListID];
        delete this.editing_Summary;
        this.log.verbose('onRowEditSave_Summary');
        this.showAreYouSure = false;
    }

    cancelSave() {
        this.summary.splice(
            this.indexForAreYouSure,
            1,
            this.clonedSummary[this.dataForAreYouSure.EmployeeListID]
        );
        delete this.clonedSummary[this.dataForAreYouSure.EmployeeListID];
        delete this.editing_Summary;
        this.showAreYouSure = false;
    }

    onEditInit_Summary($event: { data: ICurrentLeaveSummary }) {
        this.editing_Summary = { ...$event.data };
    }

    onRowEditInit_Summary(rowData: ICurrentLeaveSummary) {
        this.clonedSummary[rowData.EmployeeListID] = { ...rowData };
        this.editing_Summary = rowData;
        this.log.verbose('onRowEditInit_Summary');
    }

    onRowEditSave_Summary(rowData: ICurrentLeaveSummary) {
        // let data = this.summary.find(x => x == rowData);
        if (rowData.PolicyTitle != null) {
            // Only show PTO override warning when VAC accrual values change - sick accruals are not part of PTO policy
            const vacAccrualChanged =
                rowData.Vac_Accrualperiod !=
                    this.clonedSummary[rowData.EmployeeListID]
                        .Vac_Accrualperiod ||
                rowData.Vac_Accrualperiodvalue !=
                    this.clonedSummary[rowData.EmployeeListID]
                        .Vac_Accrualperiodvalue ||
                rowData.Vac_HoursMax !=
                    this.clonedSummary[rowData.EmployeeListID].Vac_HoursMax;
            if (vacAccrualChanged) {
                this.showAreYouSure = true;
                this.dataForAreYouSure = rowData;
                this.indexForAreYouSure = this.summary.findIndex(
                    x => x.EmployeeListID == rowData.EmployeeListID
                );
            } else {
                this.SaveSummary.next(rowData);
                delete this.clonedSummary[rowData.EmployeeListID];
                delete this.editing_Summary;
                this.log.verbose('onRowEditSave_Summary');
            }
        } else {
            this.SaveSummary.next(rowData);
            delete this.clonedSummary[rowData.EmployeeListID];
            delete this.editing_Summary;
            this.log.verbose('onRowEditSave_Summary');
        }
    }

    onRowEditCancel_Summary(rowData: ICurrentLeaveSummary, index: number) {
        this.summary.splice(
            index,
            1,
            this.clonedSummary[rowData.EmployeeListID]
        );
        delete this.clonedSummary[rowData.EmployeeListID];
        delete this.editing_Summary;
        this.log.verbose('onRowEditCancel_Summary');
    }

    // downloadClicked() {
    //     this.LATable.exportCSV();
    // }

    // exportExcel() {
    //     import("xlsx").then(xlsx => {
    //         const worksheet = xlsx.utils.json_to_sheet(this.adjustments);
    //         const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    //         const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
    //         this.saveAsExcelFile(excelBuffer, " LeaveHistory");
    //     });
    // }

    // saveAsExcelFile(buffer: any, fileName: string): void {
    //     import("file-saver").then(FileSaver => {
    //         let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    //         let EXCEL_EXTENSION = '.xlsx';
    //         const data: Blob = new Blob([buffer], {
    //             type: EXCEL_TYPE
    //         });
    //         FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    //     });
    // }

    // --------------------------LeaveAdjustment Table---------------------------------
    onEditInit($event: { data: LeaveAdjustment }) {
        this.editing_LA = { ...$event.data };
    }

    onRowEditInit(rowData: LeaveAdjustment) {
        this.clonedAdjustments[rowData.Uniqueid] = { ...rowData };
        this.editing_LA = rowData;
        this.log.verbose('onRowEditInit');
    }

    onRowEditSave(rowData: LeaveAdjustment) {
        this.SaveAdjustment.next(rowData);
        delete this.clonedAdjustments[rowData.Uniqueid];
        delete this.editing_LA;
        this.log.verbose('onRowEditSave');
    }

    onRowEditCancel(item: LeaveAdjustment) {
        const index = this.adjustments.findIndex(
            x => x.Uniqueid === item.Uniqueid
        );
        if (index >= 0) {
            this.adjustments.splice(
                index,
                1,
                this.clonedAdjustments[item.Uniqueid]
            );
        }
        this.adjustments = [...this.adjustments];

        delete this.clonedAdjustments[item.Uniqueid];
        delete this.editing_LA;
        this.log.verbose('onRowEditCancel');
    }

    commitAccrualHistoryAdjustments() {
        this.SaveAdjustment.next({
            ...this.adjustments[0],
            RebuildEmployeeAccrual: true
        });
        this.working = true;
    }

    showOnlyAdjustedAccruals(event) {
        if (event.checked === true) {
            this.LATable.clear();
            this.ppsFormGroup.controls['PPS'].reset();
            this.ppeFormGroup.controls['PPE'].reset();
            this.empFormGroup.controls['Employee'].reset();
            this.apFormGroup.controls['AccrualPeriod'].reset();
            const filtered = [] as LeaveAdjustment[];
            const filteredbyusers = this.defaultAdj.filter(
                item1 =>
                    !!this.selectedUsers.find(
                        item2 => item1.EmployeeListID === item2
                    )
            );
            const filteredadj = filteredbyusers.filter(
                x =>
                    x.Vac_HoursEarnedAdjust != null ||
                    x.Vac_EarnedCostAdjust != null ||
                    x.Sick_HoursEarnedAdjust != null ||
                    x.Sick_EarnedCostAdjust != null
            );
            if (this.hideZeroCbxValue == true) {
                filteredadj.forEach(x => {
                    if (
                        x.Vac_HoursEarned == 0 &&
                        x.Vac_HoursEarnedAdjust == null
                    ) {
                        //do not display
                    } else if (
                        x.Vac_HoursEarned == 0 &&
                        x.Vac_HoursEarnedAdjust != null
                    ) {
                        filtered.push(x);
                    } else {
                        filtered.push(x);
                    }
                });

                this.LATable.value = filtered;
            } else {
                this.LATable.value = filteredadj;
            }
        } else {
            const filtered = [] as LeaveAdjustment[];
            const filteredbyusers = this.defaultAdj.filter(
                item1 =>
                    !!this.selectedUsers.find(
                        item2 => item1.EmployeeListID === item2
                    )
            );
            if (this.hideZeroCbxValue == true) {
                filteredbyusers.forEach(x => {
                    if (
                        x.Vac_HoursEarned == 0 &&
                        x.Vac_HoursEarnedAdjust == null
                    ) {
                        //do not display
                    } else if (
                        x.Vac_HoursEarned == 0 &&
                        x.Vac_HoursEarnedAdjust != null
                    ) {
                        filtered.push(x);
                    } else {
                        filtered.push(x);
                    }
                });
                this.LATable.value = filtered;
            } else {
                this.LATable.value = filteredbyusers;
            }
            //this.LATable.value = this.defaultAdj;
        }
    }

    hideZeroAccrualRecords(event) {
        if (event.checked === true) {
            this.LATable.clear();
            this.ppsFormGroup.controls['PPS'].reset();
            this.ppeFormGroup.controls['PPE'].reset();
            this.empFormGroup.controls['Employee'].reset();
            this.apFormGroup.controls['AccrualPeriod'].reset();

            let filtered = [] as LeaveAdjustment[];

            let filteredbyusers;
            if (this.selectedUsers) {
                filteredbyusers = this.defaultAdj.filter(
                    item1 =>
                        !!this.selectedUsers.find(
                            item2 => item1.EmployeeListID === item2
                        )
                );

            } else {
                filteredbyusers = this.defaultAdj;
            }

            // const filteredbyusers = this.defaultAdj.filter(
            //     item1 =>
            //         !!this.selectedUsers.find(
            //             item2 => item1.EmployeeListID === item2
            //         )
            // );

            // let filtered = this.defaultAdj.filter(
            //     x => x.Vac_HoursEarned != 0 || x.Sick_HoursEarned != 0
            // );
            // filtered = filtered.filter(x => x.Vac_HoursEarnedAdjust != null || x.Sick_HoursEarnedAdjust != null);

            filteredbyusers.forEach(x => {
                if (x.Vac_HoursEarned == 0 && x.Vac_HoursEarnedAdjust == null) {
                    //do not display
                } else if (
                    x.Vac_HoursEarned == 0 &&
                    x.Vac_HoursEarnedAdjust != null
                ) {
                    filtered.push(x);
                } else {
                    filtered.push(x);
                }
            });

            if (this.cbxValue == true) {
                filtered = filtered.filter(
                    x =>
                        x.Vac_HoursEarnedAdjust != null ||
                        x.Vac_EarnedCostAdjust != null ||
                        x.Sick_HoursEarnedAdjust != null ||
                        x.Sick_EarnedCostAdjust != null
                );
            }
            if (this.selectedUsers) {
                var topFilter = this.adjustments.filter(
                    x =>
                        x.Vac_HoursEarnedAdjust != null ||
                        x.Vac_EarnedCostAdjust != null ||
                        x.Sick_HoursEarnedAdjust != null ||
                        x.Sick_EarnedCostAdjust != null
                );
                this.historyUsersSelectItem = topFilter.map(x => ({
                    value: x.EmployeeListID,
                    label: x.EmployeeName
                }));
            } else {
                this.historyUsersSelectItem = filtered.map(x => ({
                    value: x.EmployeeListID,
                    label: x.EmployeeName
                }));
            }


            this.LATable.value = filtered;
        } else {
            let filteredbyusers;
            if (this.selectedUsers) {
                filteredbyusers = this.defaultAdj.filter(
                    item1 =>
                        !!this.selectedUsers.find(
                            item2 => item1.EmployeeListID === item2
                        )
                );

            } else {
                filteredbyusers = this.defaultAdj;
            }
            // let filteredbyusers = this.defaultAdj.filter(
            //     item1 =>
            //         !!this.selectedUsers.find(
            //             item2 => item1.EmployeeListID === item2
            //         )
            // );

            if (this.cbxValue == true) {
                filteredbyusers = filteredbyusers.filter(
                    x =>
                        x.Vac_HoursEarnedAdjust != null ||
                        x.Vac_EarnedCostAdjust != null ||
                        x.Sick_HoursEarnedAdjust != null ||
                        x.Sick_EarnedCostAdjust != null
                );
            }

            this.historyUsersSelectItem = this.defaultAdj.map(x => ({
                value: x.EmployeeListID,
                label: x.EmployeeName
            }));

            this.LATable.value = filteredbyusers;
        }
    }

    recalcAccruals() {
        this.displayAreYouSure = true;
    }

    areYouSureConfirmed() {
        this.displayAreYouSure = false;
        this.IsLoading = true;
        this.RecalcAdjustment.next({
            id: null,
            Uniqueid: null,
            EmployeeName: null,
            EmployeeListID: null,
            PPS: this.PPS,
            PPE: this.PPE,
            VacAccrualPeriod: null,
            Vac_HoursSetting: null,
            Vac_EarnedRate: null,
            Vac_HoursEarned: null,
            Vac_EarnedCost: null,
            Vac_EarnedCostAdjust: null,
            Vac_HoursTaken: null,
            Vac_HoursEarnedAdjust: null,
            SickAccrualPeriod: null,
            Sick_HoursSetting: null,
            Sick_EarnedRate: null,
            Sick_HoursEarned: null,
            Sick_EarnedCost: null,
            Sick_EarnedCostAdjust: null,
            Sick_HoursTaken: null,
            Sick_HoursEarnedAdjust: null,
            RecalculateEmployeeLeave: true,
            RebuildEmployeeAccrual: null,
            Status: null
        } as unknown as LeaveAdjustment);
        this.recalcText = `Employee leave accruals recalculated for PPE between ${moment(
            this.PPS
        ).format('MM/DD/YYYY')} and ${moment(this.PPE).format('MM/DD/YYYY')}`;
        // this.displayRecalcText = true;
    }

    areYouSureCancelled() {
        this.displayAreYouSure = false;
    }

    filterLATable($event, filterType) {
        // use this for all table filters
        if (filterType == 'pps') {
            this.LATable.filter($event.value, 'PPS', 'in');
        } else if (filterType == 'ppe') {
            this.LATable.filter($event.value, 'PPE', 'in');
        } else if (filterType == 'name') {
            this.LATable.filter($event.value, 'EmployeeName', 'in');
        } else if (filterType == 'sickperiod') {
            this.LATable.filter($event.value, 'SickAccrualPeriod', 'in');
        } else if (filterType == 'vacperiod') {
            this.LATable.filter($event.value, 'VacAccrualPeriod', 'in');
        }
    }

    filterSummaryTable($event, filterType) {
        // use this for all table filters
        if (filterType == 'name') {
            this.SummaryTable.filter($event.value, 'EmployeeName', 'in');
        }
    }

    // handleOnOpen($event) {
    //     const baseHeight = '35vh';
    //     let accHeight = 0;
    //     if ($event.length === 1) {
    //         accHeight += 36;
    //     } else {
    //         accHeight += 0;
    //     }        
    //     if (this.activeState[0]) {
    //         this.sTabHeight = `calc(${baseHeight} + ${accHeight}vh)`;
    //     }
    //     if (this.activeState[1]) {
    //         this.hTabHeight = `calc(${baseHeight} + ${accHeight}vh)`;
    //     }

    //     // this.SummaryTable.scrollHeight = `calc(${baseHeight} + ${accHeight}em)`;
    //     this.log.verbose({
    //         type: 'LeaveAdjustmentComponent:handleOnOpen',
    //         $event,
    //         scrollHeight: this.SummaryTable.scrollHeight
    //     });
    //     this.cdRef.detectChanges();
    // }

    handleOnOpen(panel: 'summary' | 'history', event: { collapsed: boolean }) {
        if (panel === 'summary') {
            this.summaryPanelOpen = !event.collapsed;         
        } else if (panel === 'history') {
            this.historyPanelOpen = !event.collapsed;          
        }

        this.updatePanelHeights();
        
        this.log.verbose({
            type: 'LeaveAdjustmentComponent:onPanelToggle',
            summaryPanelOpen: this.summaryPanelOpen,
            historyPanelOpen: this.historyPanelOpen,
            hTabHeight: this.hTabHeight,
            sTabHeight: this.sTabHeight
        });
        this.cdRef.detectChanges();
    }

    onAccordionToggle(isOpen: boolean) {
        setTimeout(() => {
            this.syncAccordionState();
            this.cdRef.detectChanges();
        }, 0);
    }

    private syncAccordionState() {
        this.summaryPanelOpen = this.activeAccordionIndexes.includes(0);
        this.historyPanelOpen = this.activeAccordionIndexes.includes(1);
        this.updatePanelHeights();
    }

    private updatePanelHeights() {
        const openCount =
            (this.summaryPanelOpen ? 1 : 0) +
            (this.historyPanelOpen ? 1 : 0);
        if (openCount === 2) {
            this.tabHeight = '31.25vh';
        } else if (openCount === 1) {
            this.tabHeight = '62.5vh';
        } else {
            this.tabHeight = '0vh';
        }
    }

    onSelectedChargeNumberTab($event) {
        if ($event === true) {
            const event = [] as number[];
            if (this.activeState[0]) {
                event.push(0);
            }
            if (this.activeState[1]) {
                event.push(1);
            }

            setTimeout(() => {
                //this.handleOnOpen(event);
            }, 0);
        }
    }

    onChangeUser($event) {
        this.IsColumnFrozen = false;
        //need to filter for hide 0
        this.selectedUsers = $event.value;
        let filtered = [] as LeaveAdjustment[];
        if (this.hideZeroCbxValue == true) {
            this.filteredHistory = this.defaultAdj.filter(x =>
                $event.value.includes(x.EmployeeListID)
            );
            this.filteredHistory.forEach(x => {
                if (x.Vac_HoursEarned == 0 && x.Vac_HoursEarnedAdjust == null) {
                    //do not display
                } else if (
                    x.Vac_HoursEarned == 0 &&
                    x.Vac_HoursEarnedAdjust != null
                ) {
                    filtered.push(x);
                } else {
                    filtered.push(x);
                }
            });
            if (this.cbxValue == true) {
                filtered = filtered.filter(
                    x =>
                        x.Vac_HoursEarnedAdjust != null ||
                        x.Vac_EarnedCostAdjust != null ||
                        x.Sick_HoursEarnedAdjust != null ||
                        x.Sick_EarnedCostAdjust != null
                );
            }
            this.filteredHistory = filtered;
            //this.filteredHistory = this.filteredHistory.filter(x => x.Vac_HoursEarned != 0 || x.Sick_HoursEarned != 0);
            //this.filteredHistory = this.filteredHistory.filter(x => x.Vac_HoursEarnedAdjust == null || x.Sick_HoursEarnedAdjust == null);
        } else {
            this.filteredHistory = this.defaultAdj.filter(x =>
                $event.value.includes(x.EmployeeListID)
            );

            if (this.cbxValue == true) {
                this.filteredHistory = this.filteredHistory.filter(
                    x =>
                        x.Vac_HoursEarnedAdjust != null ||
                        x.Vac_EarnedCostAdjust != null ||
                        x.Sick_HoursEarnedAdjust != null ||
                        x.Sick_EarnedCostAdjust != null
                );
            }
        }
        this.LATable.value = this.filteredHistory;
        this.IsColumnFrozen = true;
    }
}
